const handleMenuMobile = () => {
  const menu = document.querySelector(".menu");
  const openBtn = document.querySelector(".menu-mobile-icon");
  const closeBtn = document.querySelector(".menu-close");

  const overlay = document.createElement('div');
  overlay.className = 'menu-overlay';
  document.body.appendChild(overlay);

  const open = () => {
    menu.classList.add("opened");
    overlay.classList.add("visible");
    document.body.style.overflow = 'hidden';
  };

  const close = () => {
    menu.classList.remove("opened");
    overlay.classList.remove("visible");
    document.body.style.overflow = '';
  };

  openBtn.addEventListener("click", open);
  closeBtn.addEventListener("click", close);
  overlay.addEventListener("click", close);
};

const handleFiltersMobile = () => {
  const filters = document.querySelector(".activities-filters");
  const openBtn = document.querySelector(".open-filters-btn");
  const closeBtn = document.querySelector(".close-filters");

  if (!filters || !openBtn || !closeBtn) return;

  openBtn.addEventListener("click", () => {
    filters.classList.add("opened");
  });

  closeBtn.addEventListener("click", () => {
    filters.classList.remove("opened");
  });
};

const handleDarkMode = () => {
  const themeToggle = document.getElementById('themeToggle');
  const body = document.body;
  const html = document.documentElement;

  // Transfere a classe do html para o body (se foi aplicada no head)
  if (html.classList.contains('dark-mode-init')) {
    body.classList.add('dark-mode');
  }
  
  // Remove dark-mode-init imediatamente após aplicar no body
  // Usa setTimeout para garantir que os estilos sem transição sejam aplicados primeiro
  setTimeout(() => {
    html.classList.remove('dark-mode-init');
  }, 0);

  themeToggle.addEventListener('click', function () {
    body.classList.toggle('dark-mode');
    
    // Garante remoção ao clicar também
    html.classList.remove('dark-mode-init');

    themeToggle.classList.add('clicked');
    setTimeout(() => {
      themeToggle.classList.remove('clicked');
    }, 300);

    if (body.classList.contains('dark-mode')) {
      localStorage.setItem('theme', 'dark');
    } else {
      localStorage.setItem('theme', 'light');
    }
  });
}

// ============================================
// FILTROS E PAGINAÇÃO DE ATIVIDADES (AJAX)
// ============================================

const handleActivityFilters = () => {
  const filtersContainer = document.querySelector('.activities-filters');
  if (!filtersContainer) return;

  // Estado
  const state = {
    currentPage: 1,
    filters: {
      categoria: [],
      ano: [],
      dificuldade: [],
      keywords: ''
    },
    orderby: 'date',
    order: 'DESC'
  };

  // Elementos
  const checkboxes = filtersContainer.querySelectorAll('input[type="checkbox"]');
  const searchInput = filtersContainer.querySelector('.filter-search');
  const resetBtn = filtersContainer.querySelector('.filters-reset');
  const activeFiltersMobile = document.querySelector('.active-filters-list');
  const paginationContainer = document.querySelector('.activities-pagination');
  const activitiesGrid = document.getElementById('activities-grid');

  // Função para fazer requisição AJAX
  const fetchActivities = () => {
    // Mostrar loading
    if (activitiesGrid) {
      activitiesGrid.style.opacity = '0.5';
      activitiesGrid.style.pointerEvents = 'none';
    }

    // Preparar dados
    const formData = new FormData();
    formData.append('action', 'filter_atividades');
    formData.append('nonce', quizikaAjax.nonce);
    formData.append('paged', state.currentPage);
    formData.append('orderby', state.orderby);
    formData.append('order', state.order);
    formData.append('keywords', state.filters.keywords);
    
    // Arrays de filtros
    state.filters.categoria.forEach(val => formData.append('categoria[]', val));
    state.filters.ano.forEach(val => formData.append('ano[]', val));
    state.filters.dificuldade.forEach(val => formData.append('dificuldade[]', val));

    // Fazer requisição
    fetch(quizikaAjax.ajaxurl, {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        // Atualizar grid
        if (activitiesGrid) {
          activitiesGrid.innerHTML = data.html;
          activitiesGrid.style.opacity = '1';
          activitiesGrid.style.pointerEvents = 'auto';
        }

        // Atualizar paginação
        renderPagination(data.total_pages);

        // Scroll suave para o topo
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    })
    .catch(error => {
      console.error('Erro ao filtrar atividades:', error);
      if (activitiesGrid) {
        activitiesGrid.style.opacity = '1';
        activitiesGrid.style.pointerEvents = 'auto';
      }
    });
  };

  // Função para renderizar paginação
  const renderPagination = (totalPages) => {
    if (!paginationContainer) return;

    if (totalPages <= 1) {
      paginationContainer.style.display = 'none';
      return;
    }

    paginationContainer.style.display = 'flex';
    paginationContainer.innerHTML = '';

    const range = 2;

    // Botão anterior
    const prevBtn = document.createElement('button');
    prevBtn.className = 'pagination-btn';
    prevBtn.setAttribute('aria-label', 'Página anterior');
    prevBtn.disabled = state.currentPage === 1;
    prevBtn.innerHTML = `
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M10 12L6 8L10 4" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
    `;
    prevBtn.addEventListener('click', () => {
      if (state.currentPage > 1) {
        state.currentPage--;
        fetchActivities();
      }
    });
    paginationContainer.appendChild(prevBtn);

    // Primeira página
    if (state.currentPage > range + 2) {
      const firstBtn = createPageButton(1);
      paginationContainer.appendChild(firstBtn);
    }

    // Reticências antes
    if (state.currentPage > range + 3) {
      const ellipsis = document.createElement('span');
      ellipsis.className = 'pagination-ellipsis';
      ellipsis.textContent = '...';
      paginationContainer.appendChild(ellipsis);
    }

    // Páginas ao redor da atual
    for (let i = Math.max(1, state.currentPage - range); i <= Math.min(totalPages, state.currentPage + range); i++) {
      const pageBtn = createPageButton(i, i === state.currentPage);
      paginationContainer.appendChild(pageBtn);
    }

    // Reticências depois
    if (state.currentPage < totalPages - range - 2) {
      const ellipsis = document.createElement('span');
      ellipsis.className = 'pagination-ellipsis';
      ellipsis.textContent = '...';
      paginationContainer.appendChild(ellipsis);
    }

    // Última página
    if (state.currentPage < totalPages - range - 1) {
      const lastBtn = createPageButton(totalPages);
      paginationContainer.appendChild(lastBtn);
    }

    // Botão próximo
    const nextBtn = document.createElement('button');
    nextBtn.className = 'pagination-btn';
    nextBtn.setAttribute('aria-label', 'Próxima página');
    nextBtn.disabled = state.currentPage === totalPages;
    nextBtn.innerHTML = `
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
    `;
    nextBtn.addEventListener('click', () => {
      if (state.currentPage < totalPages) {
        state.currentPage++;
        fetchActivities();
      }
    });
    paginationContainer.appendChild(nextBtn);
  };

  // Criar botão de página
  const createPageButton = (pageNum, isActive = false) => {
    const btn = document.createElement('button');
    btn.className = 'pagination-btn' + (isActive ? ' active' : '');
    btn.textContent = pageNum;
    if (isActive) {
      btn.setAttribute('aria-current', 'page');
    }
    btn.addEventListener('click', () => {
      state.currentPage = pageNum;
      fetchActivities();
    });
    return btn;
  };

  // Função para criar pill de filtro ativo
  const createFilterPill = (filterType, value) => {
    const pill = document.createElement('span');
    pill.className = 'active-filter-pill';
    pill.dataset.filterType = filterType;
    pill.dataset.filterValue = value;
    pill.innerHTML = `
      ${value}
      <button class="remove-filter" aria-label="Remover filtro">×</button>
    `;
    
    pill.querySelector('.remove-filter').addEventListener('click', (e) => {
      e.stopPropagation();
      removeFilter(filterType, value);
    });
    
    return pill;
  };

  // Função para atualizar pills de filtros ativos
  const updateFilterPills = () => {
    if (activeFiltersMobile) activeFiltersMobile.innerHTML = '';

    ['categoria', 'ano', 'dificuldade'].forEach(filterType => {
      state.filters[filterType].forEach(value => {
        const pillMobile = createFilterPill(filterType, value);
        if (activeFiltersMobile) activeFiltersMobile.appendChild(pillMobile);
      });
    });
  };

  // Função para remover filtro específico
  const removeFilter = (filterType, value) => {
    const index = state.filters[filterType].indexOf(value);
    if (index > -1) {
      state.filters[filterType].splice(index, 1);
    }

    const checkbox = filtersContainer.querySelector(
      `input[data-filter="${filterType}"][value="${value}"]`
    );
    if (checkbox) {
      checkbox.checked = false;
    }

    state.currentPage = 1;
    updateFilterPills();
    fetchActivities();
  };

  // Event listeners para checkboxes
  checkboxes.forEach(checkbox => {
    checkbox.addEventListener('change', () => {
      const filterType = checkbox.dataset.filter;
      const value = checkbox.value;

      if (checkbox.checked) {
        if (!state.filters[filterType].includes(value)) {
          state.filters[filterType].push(value);
        }
      } else {
        const index = state.filters[filterType].indexOf(value);
        if (index > -1) {
          state.filters[filterType].splice(index, 1);
        }
      }

      state.currentPage = 1;
      updateFilterPills();
      fetchActivities();
    });
  });

  // Event listener para busca (com debounce)
  let searchTimeout;
  if (searchInput) {
    searchInput.addEventListener('input', (e) => {
      clearTimeout(searchTimeout);
      searchTimeout = setTimeout(() => {
        state.filters.keywords = e.target.value;
        state.currentPage = 1;
        fetchActivities();
      }, 500); // Aguarda 500ms após parar de digitar
    });
  }

  // Event listener para reset
  if (resetBtn) {
    resetBtn.addEventListener('click', () => {
      state.filters.categoria = [];
      state.filters.ano = [];
      state.filters.dificuldade = [];
      state.filters.keywords = '';
      state.currentPage = 1;
      state.orderby = 'date';
      state.order = 'DESC';

      checkboxes.forEach(cb => cb.checked = false);
      if (searchInput) searchInput.value = '';

      updateFilterPills();
      fetchActivities();
    });
  }

  // Inicializar paginação da página inicial
  if (paginationContainer) {
    const initialTotalPages = parseInt(paginationContainer.dataset.totalPages) || 1;
    if (initialTotalPages > 1) {
      renderPagination(initialTotalPages);
    }
  }
};

// ============================================
// BUSCA NO HEADER
// ============================================

const handleSearch = () => {
  const toggle = document.getElementById('search-toggle');
  const headerDiv = document.querySelector('.header');
  const mobileDrop = document.getElementById('search-mobile-drop');
  const desktopField = document.querySelector('.search-field');
  const mobileField = document.querySelector('.search-field-mobile');

  if (!toggle) return;

  const isDesktop = () => window.matchMedia('(min-width: 1024px)').matches;

  const open = () => {
    toggle.setAttribute('aria-expanded', 'true');
    if (isDesktop()) {
      headerDiv.classList.add('search-active');
      setTimeout(() => desktopField && desktopField.focus(), 350);
    } else {
      mobileDrop.classList.add('active');
      setTimeout(() => mobileField && mobileField.focus(), 350);
    }
  };

  const close = () => {
    toggle.setAttribute('aria-expanded', 'false');
    headerDiv.classList.remove('search-active');
    if (mobileDrop) mobileDrop.classList.remove('active');
  };

  toggle.addEventListener('click', (e) => {
    e.stopPropagation();
    toggle.getAttribute('aria-expanded') === 'true' ? close() : open();
  });

  document.addEventListener('click', (e) => {
    if (!e.target.closest('#site-search') && !e.target.closest('#search-mobile-drop')) {
      close();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close();
  });
};

// ============================================
// ACCORDIONS DE FILTROS
// ============================================

const handleFilterAccordions = () => {
  const accordionHeaders = document.querySelectorAll('.filter-group-header');

  accordionHeaders.forEach(header => {
    header.addEventListener('click', () => {
      const isExpanded = header.getAttribute('aria-expanded') === 'true';
      const content = header.nextElementSibling;

      // Toggle accordion
      if (isExpanded) {
        header.setAttribute('aria-expanded', 'false');
        content.setAttribute('hidden', '');
      } else {
        header.setAttribute('aria-expanded', 'true');
        content.removeAttribute('hidden');
      }
    });
  });
};

// Garante que o código rode após o DOM estar completamente carregado
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    handleMenuMobile();
    handleFiltersMobile();
    handleDarkMode();
    handleActivityFilters();
    handleFilterAccordions();
    handleSearch();
  });
} else {
  // DOM já está pronto
  handleMenuMobile();
  handleFiltersMobile();
  handleDarkMode();
  handleActivityFilters();
  handleFilterAccordions();
  handleSearch();
}
